import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './SchoolAdmin.module.css'
import {
  ConfigProvider,
  Menu,
  message,
  Tooltip,
} from 'antd'

import menu_userManage from './menu_userManage.svg'
import menu_userManage_selected from './menu_userManage_selected.svg'


import zhuanshiIcon from './zhuanshi.svg'

import TeacherManager from './teacherManager/teacherManager.js'
import { selectCurrentMenuKey, setCurrentMenuKey } from './SchoolAdminSlice.js'
import {
  changeTipStatusRequest,
  getUserPointsRequest,
} from './SchoolAdminApi.js'
import UserRechargePoints from './UserRechargePoints/UserRechargePoints.js'
import MyPointsInfo from './MyPointsInfo/MyPointsInfo.js'
import Cookies from 'js-cookie'
import UserInfoManager from './UserInfoManager/UserInfoManager.js'
import ShoolAdminTip from './ShoolAdminTip/ShoolAdminTip.js'
import { clearAllCookies } from '../../util/handleObject.js'
export default function SchoolAdmin() {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const current = useSelector(selectCurrentMenuKey)
  const [arrow, setArrow] = useState('Show')
  const [userName, setUserName] = useState(Cookies.get('name'))
  const [userHeaderImg, setUserHeaderImg] = useState(
    Cookies.get('image_url'),
  )
  const [showPointsInfo, setShowPointsInfo] = useState(false)
  const [showUserInfoManager, setShowUserInfoManager] = useState(false)

  const mergedArrow = useMemo(() => {
    if (arrow === 'Hide') {
      return false
    }
    if (arrow === 'Show') {
      return true
    }
    return {
      pointAtCenter: true,
    }
  }, [arrow])
  const schoolAdminMenus = [
    {
      key: '6',
      // icon: <PieChartOutlined />,
      icon: (
        <img
          src={
            String(
              Math.abs(current) > 10 ? Math.floor(current / 10) : current,
            ) == 6
              ? menu_userManage_selected
              : menu_userManage
          }
          width={25}
          height={25}
        />
      ),
      label: '用户管理',
    },
  ]
  const [userPoints, setUserPoints] = useState(0)
  const [showSchoolAdminTip, setShowSchoolAdminTip] = useState(false)


  function getUrlParams(url) {
    const urlParams = new URLSearchParams(url.split('?')[1]);
    const params = {};
    for (let param of urlParams.entries()) {
      params[param[0]] = param[1];
    }
    return params;
  }
  function removeAllQueryParams() {
      const url = new URL(window.location);
      url.search = ''; // 清空查询参数
      window.history.pushState({}, '', url.toString()); // 更新浏览器地址栏
  }




  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行

    if(sessionStorage.getItem('currentMenuKey')){
      changeMenuMethod({key:sessionStorage.getItem('currentMenuKey')})
    }
    let params = getUrlParams(window.location.href)
    if(params.outTradeNo){
      setShowPointsInfo(true)
      sessionStorage.setItem('rechargeCurrent',2)
      removeAllQueryParams()
    }
    if(Cookies.get('type') == 2&&Cookies.get('admin_show_tip')==1){
      showSchoolTip()
    }

    getUserPoints()
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  function showSchoolTip() {
    changeTipStatusRequest((data)=>{
      if(data.ret == 1){
        Cookies.set('admin_show_tip',0)
        setShowSchoolAdminTip(true)
      }
      else if(data.ret == 99){
        messageApi.open({
          type: 'warning',
          // content: data.msg,
          content: data.msg,
        })
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      }
      else{
        messageApi.error(data.msg, 1)
      }
    })
  }
  const getUserPoints = () => {
    getUserPointsRequest((data) => {
      if(data.ret == 1){
        Cookies.set('jifen', data.data.user_jifen)
        Cookies.set('fenpei_jifen', parseInt(data.data.user_jifen)-parseInt(data.data.school_chongzhi_shengyu_jifen))
        Cookies.set('chongzhi_jifen', data.data.school_chongzhi_shengyu_jifen)
        setUserPoints(data.data.user_jifen)
      }
    })
  }
  const changeMenuMethod = (e) => {
    setShowUserInfoManager(false)
    dispatch(setCurrentMenuKey(e.key))
    getUserPoints()
  }
  return (
    <div
      className={styles.background}
      //  onKeyDown={keyPress}
    >
      {contextHolder}
      <div className={styles.leftMenus}>
        <img
          className={styles.menuLogo}
          src={require('../../assert/logo_name_icon.png')}
        ></img>
        <div
          className={styles.headerContainer}
          onClick={(e) => {
            if (!showPointsInfo) {
              setShowUserInfoManager(true)
            }
          }}
        >
          <img
            className={styles.avatar}
            src={
              userHeaderImg == 'null' || userHeaderImg == ''
                ? require('./avatar.png')
                : userHeaderImg
            }
          ></img>
          <div className={styles.rightBox}>
            <Tooltip placement="bottom" title={userName} arrow={mergedArrow}>
              <text className={styles.teacherName}>{userName}</text>
            </Tooltip>
            <div
              className={styles.gdnInfo}
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                getUserPoints()
                sessionStorage.setItem('rechargeCurrent',0)
                setShowPointsInfo(true)
              }}
            >
              <text className={styles.gdnTag}>
                {parseInt(Cookies.get('jifen')) <
                parseInt(userPoints)
                  ? Cookies.get('jifen')
                  : userPoints}
              </text>
              <text style={{ minWidth: '40px' }}>积分</text>
            </div>

            <div className={styles.rightTop}>
              <img src={zhuanshiIcon} /> <b style={{ marginLeft: 4 }}>Lv1</b>
            </div>
            {showPointsInfo ? (
              <MyPointsInfo
                openStatus={showPointsInfo}
                onCancel={(e) => {
                  setShowPointsInfo(false)
                }}
              />
            ) : null}
          </div>
        </div>
        {Cookies.get('school_name')!="null" && <div className={styles.schoolBox}>
          <div className={styles.schoolName}>{Cookies.get('school_name')}</div>
        </div>}
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#f5b544',
            },
          }}
        >
          <Menu
            defaultSelectedKeys={
              Cookies.get('type') == 2 ? ['0'] : ['1']
            }
            // defaultOpenKeys={[sessionStorage.getItem('currentMenuKey').substring(0,1)]}
            defaultOpenKeys={[current.toString().substring(0,1)]}
            mode="inline"
            items={schoolAdminMenus}
            onClick={changeMenuMethod}
            selectedKeys={String(
              Math.abs(current) > 60 ? Math.floor(current / 10) : current,
            )}
            inlineCollapsed={false}
          />
        </ConfigProvider>

        {/* <div className={styles.shoppingCartContainer}>
                    <text className={styles.payName}>去支付</text>
                    <img className={styles.shoppingCart} src={require('./shopping_cart.png')}></img>
                </div> */}
      </div>
      <div className={styles.rightMenus}>
        {showUserInfoManager ? (
          <UserInfoManager
            onCancel={() => {
              changeMenuMethod({
                key: current,
              })
              setShowUserInfoManager(false)
            }}
            changeUserAvatar={(value) => {
              Cookies.set('image_url', value)
              setUserHeaderImg(value)
            }}
            changeUserName={(value) => {
              Cookies.set('name', value)
              setUserName(value)
            }}
          />
        ) : current == 6 ? (
          <TeacherManager />
        ) : current == 61 ? (
          <UserRechargePoints />
        ) :  (

          <div></div>
        )}
        {showSchoolAdminTip && <ShoolAdminTip closeCommonModal={()=>{
          setShowSchoolAdminTip(false)
        }} openStatus={showSchoolAdminTip} />}
      </div>
    </div>
  )
}

